import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import firebase from "firebase/app";
import "firebase/auth"; // for authentication
import "firebase/firestore";
import "firebase/storage";
import "firebase/functions";
import "firebase/messaging";
import "./registerServiceWorker";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import VueLodash from "vue-lodash";
import lodash from "lodash";
import "@/plugins/apexcharts";
import VueExcelXlsx from "vue-excel-xlsx";
Vue.use(VueExcelXlsx);
import UUID from "vue-uuid";
Vue.use(UUID);
import Vuelidate from "vuelidate";
Vue.use(Vuelidate);
// ...
import VueHtmlToPaper from "vue-html-to-paper";

// ...

import { LoadingPlugin } from "vuetify-loading-overlay";
Vue.use(LoadingPlugin, {
  //props
  spinnerProps: {},
  overlayProps: {},
});

import JsonExcel from "vue-json-excel"; 
Vue.component("downloadExcel", JsonExcel);

/* //MultiFiltersPlugin
import MultiFiltersPlugin from "./plugins/MultiFilters";
Vue.use(MultiFiltersPlugin); */

const options = {
  "name": "_blank",
  "specs": [
    "fullscreen=yes",
    "titlebar=yes",
    "scrollbars=yes"
  ],
  "styles": [
    "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
    "https://unpkg.com/kidlat-css/css/kidlat.css", 
  ],
  "timeout": 1000,
  "autoClose": true,
  "windowTitle": "Impression"
};
Vue.use(VueHtmlToPaper, options);

const moment = require("moment");
require("moment/locale/fr");
Vue.use(require("vue-moment"), {
  moment,
});
// name is optional
Vue.use(VueLodash, { name: "custom", lodash: lodash });
//Vue.prototype.$lodash = VueLodash;

Vue.config.productionTip = false;

// Your web app's Firebase configuration
var firebaseConfig = {
  apiKey: "AIzaSyBHRBVmEdNi05KQKCLLNbdUVfgMEB_3w4A",
  authDomain: "osdrmdatabse.firebaseapp.com",
  databaseURL: "https://osdrmdatabse.firebaseio.com",
  projectId: "osdrmdatabse",
  storageBucket: "osdrmdatabse.appspot.com",
  messagingSenderId: "397639461706",
  appId: "1:397639461706:web:1d6285ca0f17ca2542afb3",
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
//firebase.firestore.setLogLevel('debug');
firebase.firestore().settings({
  cacheSizeBytes: firebase.firestore.CACHE_SIZE_UNLIMITED,
});
// enable offline persistence
firebase
  .firestore()
  .enablePersistence({
    synchronizeTabs: true,
  })
  .catch((err) => {
    if (err.code == "failed-precondition") {
    } else if (err.code == "unimplemented") {
    }
  });

// enable auth persistence
firebase
  .auth()
  .setPersistence(firebase.auth.Auth.Persistence.LOCAL)
  .then(function () {
    //return firebase.auth().signInWithEmailAndPassword(email, password);
  })
  .catch(function (error) {
    console.log(error);
  });

Vue.prototype.$firebase = firebase;

const firebaseErrors = {
  "auth/user-not-found": "Pas d'utilisateur correspondant",
  "auth/email-already-in-use": "Email déja utilisé",
  "auth/weak-password":
    "Le mot de passe doit comprendre au moins 6 caractères ",
};
Vue.prototype.$firebaseErrors = firebaseErrors;
//used_langage
const used_langage = "fr";

// Langage Elements
const Lang = {
  fr: {
    signup: "S'enregister",
    login: "Se connecter",
    logout: "Se déconnecter",
    account: "Compte",
    emailAddress: "Aresse email",
    password: "Mot de passe",
    home: "Accueil",
    superAdmin: "Super A",
    admin: "Administrateur",
    about: "A propos",
    haveAccount: "Vous avez déja un compte?",
    notHaveAccount: "Vous n'avez pas encore de compte?",
    superviseur: "Superviseur",
    groupe: "Groupe",
    notFound: "(404) Cette page n'esiste pas",
  },
  en: {
    signup: "Sign up",
    login: "Login",
    logout: "Logout",
    account: "Account",
    password: "Password",
    superAdmin: "Super A",
    admin: "Administrator",
    about: "About",
    haveAccount: "Don't have an account?",
    notHaveAccount: " Don't have an account?",
    superviseur: "Supervisor",
    groupe: "Group",
    notFound: "(404) Page NotFound",
  },
};
Vue.prototype.$lang = Lang[used_langage];

const provinces = [
  {
    id_province: 1,
    ll_province: "ANTANANARIVO",
    countries_code_country: 133,
  },
  {
    id_province: 2,
    ll_province: "FIANARANTSOA",
    countries_code_country: 133,
  },
  {
    id_province: 3,
    ll_province: "TOAMASINA",
    countries_code_country: 133,
  },
  {
    id_province: 4,
    ll_province: "MAHAJANGA",
    countries_code_country: 133,
  },
  {
    id_province: 5,
    ll_province: "TOLIARY",
    countries_code_country: 133,
  },
  {
    id_province: 7,
    ll_province: "ANTSIRANANA",
    countries_code_country: 133,
  },
];
const regions = [
  {
    id_region: 11,
    ll_region: "ANALAMANGA",
    province_id_province: 1,
    is_inactive: 0,
  },
  {
    id_region: 12,
    ll_region: "VAKINANKARATRA",
    province_id_province: 1,
    is_inactive: 0,
  },
  {
    id_region: 13,
    ll_region: "ITASY",
    province_id_province: 1,
    is_inactive: 0,
  },
  {
    id_region: 14,
    ll_region: "BONGOLAVA",
    province_id_province: 1,
    is_inactive: 0,
  },
  {
    id_region: 21,
    ll_region: "HAUTE MATSIATRA",
    province_id_province: 2,
    is_inactive: 0,
  },
  {
    id_region: 22,
    ll_region: "AMORON I MANIA",
    province_id_province: 2,
    is_inactive: 0,
  },
  {
    id_region: 23,
    ll_region: "VATOVAVY FITOVINANY",
    province_id_province: 2,
    is_inactive: 0,
  },
  {
    id_region: 24,
    ll_region: "IHOROMBE",
    province_id_province: 2,
    is_inactive: 0,
  },
  {
    id_region: 25,
    ll_region: "ATSIMO ATSINANANA",
    province_id_province: 2,
    is_inactive: 0,
  },
  {
    id_region: 31,
    ll_region: "ATSINANANA",
    province_id_province: 3,
    is_inactive: 0,
  },
  {
    id_region: 32,
    ll_region: "ANALANJIROFO",
    province_id_province: 3,
    is_inactive: 0,
  },
  {
    id_region: 33,
    ll_region: "ALAOTRA MANGORO",
    province_id_province: 3,
    is_inactive: 0,
  },
  {
    id_region: 41,
    ll_region: "BOENY",
    province_id_province: 4,
    is_inactive: 0,
  },
  {
    id_region: 42,
    ll_region: "SOFIA",
    province_id_province: 4,
    is_inactive: 0,
  },
  {
    id_region: 43,
    ll_region: "BETSIBOKA",
    province_id_province: 4,
    is_inactive: 0,
  },
  {
    id_region: 44,
    ll_region: "MELAKY",
    province_id_province: 4,
    is_inactive: 0,
  },
  {
    id_region: 51,
    ll_region: "ATSIMO ANDREFANA",
    province_id_province: 5,
    is_inactive: 0,
  },
  {
    id_region: 52,
    ll_region: "ANDROY",
    province_id_province: 5,
    is_inactive: 0,
  },
  {
    id_region: 53,
    ll_region: "ANOSY",
    province_id_province: 5,
    is_inactive: 0,
  },
  {
    id_region: 54,
    ll_region: "MENABE",
    province_id_province: 5,
    is_inactive: 0,
  },
  {
    id_region: 71,
    ll_region: "DIANA",
    province_id_province: 7,
    is_inactive: 0,
  },
  {
    id_region: 72,
    ll_region: "SAVA",
    province_id_province: 7,
    is_inactive: 0,
  },
];
Vue.prototype.$provinces = provinces;
Vue.prototype.$regions = regions;
Vue.prototype.$firebaseErrors = firebaseErrors;
Vue.prototype.$appName = "GEC - Groupes d'épargne Communautaire";
Vue.prototype.$appShortName = "OSDRM DATABASE";

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
